import MonetaryAmount from '../MonetaryAmount';
import PricingData from '../pricingData/PricingData';
import CorePricedItem from './CorePricedItem';
import { CancellationType } from '../../constants/cancellationType';

export type LineItemState = {
  quantity: number;
  state: string;
  detail: CancellationType | null;
};

export type LineItemTrackingData = {
  lineItemId: string;
  trackingId: string;
  trackingUrl: string;
  dateReceived: string;
};

enum TrackingStage {
  ORDER_PLACED,
  IN_PRODUCTION,
  IN_TRANSIT,
  DELIVERED,
}
enum TrackingState {
  NOT_STARTED,
  IN_PROGRESS,
  DELAYED,
  COMPLETE,
}

type LineItemPackageStatusDetail = {
  trackingStage: TrackingStage;
  trackingState: TrackingState;
  date: string;
};

export type LineItemPackageDetail = {
  quantity: number;
  trackingId: string;
  trackingUrl: string;
  lineItemPackageStatusDetails: LineItemPackageStatusDetail[];
};

export type ProductAttribute = {
  key: string;
  value: string;
  keyDisplayName: string;
  valueDisplayName: string;
};

enum LineItemFulfillmentHoldType {
  DESIGN,
  MAILING_SERVICES,
  UNKNOWN,
}

export type LineItemFulfillmentHold = {
  id: string;
  owner: string;
  type: LineItemFulfillmentHoldType;
  active: boolean;
  additionalData: object;
  releaseDate: string;
};

export type LineItemGroupInfo = {
  groupId: string;
  groupDisplayIndex: number;
};

class LineItemDetails {
  id: string;

  productName: string;

  productKey: string;

  quantity: number;

  states: LineItemState[];

  totalListPrice: MonetaryAmount;

  totalDiscountedPrice: MonetaryAmount;

  shippingPrice: MonetaryAmount;

  shippingTaxPrice: MonetaryAmount;

  itemTaxInfo: object;

  documentUrl: string;

  documentId: string;

  livePreviewUrl: string;

  editDocumentUrl: string;

  legacyProductConfigId: string;

  isReorderable: boolean;

  reorderUrl: string;

  trackingUrl: string;

  trackingId: string;

  pricingBreakdown: CorePricedItem;

  docReviewRequired: boolean;

  docReviewNotes: string;

  isDeliverable: boolean;

  customOrderData: object;

  purcsData: object;

  promisedArrivalDate: string;

  trackingData: LineItemTrackingData[];

  trackingDetails: LineItemPackageDetail[];

  uxModSpecs: object[];

  taxTypes: string[];

  displayProductAttributes: ProductAttribute[];

  productVersion: number;

  productConfigUrl: string;

  fulfillmentHoldsV2: LineItemFulfillmentHold[];

  groupInfo: LineItemGroupInfo;

  knownDeliveredQuantity: number;

  lastDeliveryDate: string;

  pricingData: PricingData;

  shippingPricingData: PricingData;

  constructor(lineItem?: Partial<LineItemDetails>) {
    this.id = lineItem?.id || '';
    this.productName = '';
    this.productKey = '';
    this.quantity = 0;
    this.states = [];
    this.totalListPrice = new MonetaryAmount();
    this.totalDiscountedPrice = new MonetaryAmount();
    this.shippingPrice = new MonetaryAmount();
    this.shippingTaxPrice = new MonetaryAmount();
    this.itemTaxInfo = {};
    this.documentUrl = '';
    this.documentId = '';
    this.livePreviewUrl = '';
    this.editDocumentUrl = '';
    this.legacyProductConfigId = '';
    this.isReorderable = false;
    this.reorderUrl = '';
    this.trackingUrl = '';
    this.trackingId = '';
    this.pricingBreakdown = new CorePricedItem();
    this.docReviewRequired = false;
    this.docReviewNotes = '';
    this.isDeliverable = false;
    this.customOrderData = {};
    this.purcsData = {};
    this.promisedArrivalDate = '';
    this.trackingData = [];
    this.trackingDetails = [];
    this.uxModSpecs = [];
    this.taxTypes = [];
    this.displayProductAttributes = [];
    this.productVersion = 0;
    this.productConfigUrl = '';
    this.fulfillmentHoldsV2 = [];
    this.groupInfo = {
      groupId: '',
      groupDisplayIndex: 0,
    };
    this.knownDeliveredQuantity = 0;
    this.lastDeliveryDate = '';
    this.pricingData = new PricingData();
    this.shippingPricingData = new PricingData();
  }
}

export default LineItemDetails;
